import o from"./getWindowScroll.js";import r from"./getWindow.js";import{isHTMLElement as t}from"./instanceOf.js";import e from"./getHTMLElementScroll.js";function m(m){return m!==r(m)&&t(m)?e(m):o(m)}export{m as default};
//# sourceMappingURL=getNodeScroll.js.map
